import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, Teleport as _Teleport } from "vue"
import _imports_0 from '../../assets/img/eu-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "EU",
  width: "72",
  height: "48"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "video-wrapper__sticky-close"
}
const _hoisted_3 = {
  key: 0,
  class: "static-page__gallery-badge"
}
const _hoisted_4 = { class: "static-page__info" }
const _hoisted_5 = { class: "static-page__created" }
const _hoisted_6 = { class: "static-page__buttons" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Link másolása ")
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "static-page__socials" }
const _hoisted_11 = {
  key: 6,
  class: "static-page__bottom-tags"
}
const _hoisted_12 = { class: "static-page__sticky-banner" }
const _hoisted_13 = {
  key: 7,
  ref: "scripts",
  class: "static-page__content-scripts"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_banner_widget = _resolveComponent("banner-widget")!
  const _component_Close = _resolveComponent("Close")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_Image = _resolveComponent("Image")!
  const _component_GalleryOutline = _resolveComponent("GalleryOutline")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Facebook = _resolveComponent("Facebook")!
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!
  const _component_content_widget_renderer = _resolveComponent("content-widget-renderer")!
  const _component_minute_by_minute = _resolveComponent("minute-by-minute")!
  const _component_facebook_follow = _resolveComponent("facebook-follow")!
  const _component_tag = _resolveComponent("tag")!
  const _component_ContentListWidget = _resolveComponent("ContentListWidget")!
  const _component_dynamic_script = _resolveComponent("dynamic-script")!
  const _component_page_layout = _resolveComponent("page-layout")!
  const _component_adult_confirm = _resolveComponent("adult-confirm")!
  const _component_recommended_video_widget = _resolveComponent("recommended-video-widget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.content)
      ? (_openBlock(), _createBlock(_component_adult_confirm, {
          key: 0,
          id: "main-content",
          "age-rating": _ctx.content.ageRating
        }, {
          default: _withCtx(() => [
            _createVNode(_component_page_layout, {
              id: "main-content",
              class: "static-page",
              title: _ctx.content.title
            }, {
              topheader: _withCtx(() => [
                (_ctx.content.headingTag?.slug === 'europa')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'tags', params: { tag: 'europa' }}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "topheader", { content: _ctx.content })
              ]),
              banner: _withCtx(() => [
                _createVNode(_component_banner_widget, {
                  zone: 'leaderboard_1',
                  class: "static-page__banner static-page__banner--leaderboard"
                })
              ]),
              subheader: _withCtx(() => [
                _renderSlot(_ctx.$slots, "subheader", { content: _ctx.content })
              ]),
              side: _withCtx(() => [
                _createVNode(_component_banner_widget, {
                  class: "static-page__banner static-page__banner--side",
                  zone: { desktop: 'medium_rectangle_0' },
                  "show-background": false
                }),
                _createVNode(_component_facebook_follow, { type: "desktop" }),
                _createVNode(_component_banner_widget, {
                  class: "static-page__banner static-page__banner--side",
                  zone: { desktop: 'medium_rectangle_1' },
                  "show-background": false
                }),
                _createVNode(_component_ContentListWidget, {
                  class: "static-page__popular",
                  payload: { folderIds: [], nsfwContent: _ctx.content.nsfwFlag ? undefined : 0, order: [{ field: 'topn', direction: 'desc' }], interval: 'lastDay', limit: 20 },
                  title: 'Népszerű',
                  "btn-url": { name: 'rss' },
                  length: 3,
                  shuffle: true,
                  lazy: true,
                  "is-vertical": true,
                  "show-lead": false,
                  "show-image": true,
                  "show-border": true,
                  "data-content-block": "nepszeru"
                }, null, 8, ["payload"]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_banner_widget, {
                    zone: { desktop: 'medium_rectangle_2' },
                    "show-background": false
                  })
                ])
              ]),
              footer: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer", { content: _ctx.content })
              ]),
              after: _withCtx(() => [
                _renderSlot(_ctx.$slots, "after", { content: _ctx.content })
              ]),
              default: _withCtx(() => [
                (_ctx.content.params.embedVideoUrl)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["static-page__featured-wrapper static-page__featured-video-wrapper", { 'static-page__featured-video-wrapper--sticky': _ctx.isVideoSticky }])
                    }, [
                      (_ctx.isVideoSticky && _ctx.isShowClose)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_Close, {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVideoSticky = false))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_VideoPlayer, {
                        class: "static-page__featured",
                        "video-src": _ctx.content.params.embedVideoUrl,
                        title: _ctx.content.title,
                        autoplay: false,
                        source: _ctx.$route.query.source,
                        medium: _ctx.$route.query.medium,
                        campaign: _ctx.$route.query.campaign,
                        pip: true
                      }, null, 8, ["video-src", "title", "source", "medium", "campaign"])
                    ], 2))
                  : (_ctx.content.leadImageUrls)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["static-page__featured-wrapper", {
          'static-page__featured-wrapper--gallery': _ctx.isGallery
        }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isGallery ? _ctx.galleryClick() : null))
                      }, [
                        _createVNode(_component_Image, {
                          "image-url": _ctx.content.leadImageUrls?.leadImageUrl169,
                          alt: _ctx.content.title,
                          class: "static-page__featured"
                        }, null, 8, ["image-url", "alt"]),
                        (_ctx.isGallery)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_GalleryOutline)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$d(_ctx.content.releaseDate, 'long' )), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: "static-page__button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["btn-tooltip", {'btn-tooltip--open': _ctx.copyHelper.isCopied}])
                      }, "Vágólapra másolva", 2),
                      _createVNode(_component_Link),
                      _hoisted_7
                    ]),
                    _createVNode(_component_ShareNetwork, {
                      class: "static-page__button social-share__button",
                      network: "facebook",
                      url: _ctx.publicUrl,
                      title: _ctx.content.alternativeTitle || _ctx.content.title,
                      description: _ctx.stripTags(_ctx.content.alternativeLead || _ctx.content.lead),
                      quote: _ctx.stripTags(_ctx.content.alternativeLead || _ctx.content.lead),
                      onClickCapture: _cache[3] || (_cache[3] = ($event: any) => (_ctx.measureShare('Facebook')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Facebook)
                      ]),
                      _: 1
                    }, 8, ["url", "title", "description", "quote"])
                  ])
                ]),
                (_ctx.content.lead)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "static-page__content static-page__content--lead",
                      innerHTML: _ctx.content.lead
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createVNode(_component_banner_widget, {
                  class: "static-page__banner static-page__banner--roadblock",
                  zone: { desktop: 'roadblock_1', tablet: 't_leaderboard_2', mobile: 'm_leaderboard_2', app: 'app_leaderboard_2' },
                  "label-position": "bottom"
                }),
                (_ctx.contentBody && _ctx.contentBody.html)
                  ? (_openBlock(), _createBlock(_component_content_widget_renderer, {
                      key: 3,
                      class: "static-page__body",
                      html: _ctx.fixLinkTarget(_ctx.contentBody.html),
                      widgets: _ctx.content.widgets,
                      ref: "content",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.measureLink($event)))
                    }, null, 8, ["html", "widgets"]))
                  : _createCommentVNode("", true),
                (_ctx.isMinuteByMinuteContent)
                  ? (_openBlock(), _createBlock(_component_minute_by_minute, {
                      key: 4,
                      "content-id": _ctx.content.id
                    }, null, 8, ["content-id"]))
                  : _createCommentVNode("", true),
                (_ctx.content.disclaimer)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "static-page__content",
                      innerHTML: _ctx.content.disclaimer
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createVNode(_component_banner_widget, {
                  class: "static-page__banner static-page__banner--roadblock static-page__banner--roadblock-after",
                  zone: { desktop: 'roadblock_7', mobile: 'm_medium_rectangle_5', app: 'app_medium_rectangle_5' }
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args))),
                    class: "static-page__button"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["btn-tooltip", {'btn-tooltip--open': _ctx.copyHelper.isCopied}])
                    }, "Vágólapra másolva", 2),
                    _createVNode(_component_Link)
                  ]),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['facebook', 'twitter', 'viber'], (social, i) => {
                    return _createVNode(_component_ShareNetwork, {
                      key: i,
                      class: _normalizeClass(`static-page__button static-page__button--social social-share__button static-page__button--${social}`),
                      network: social,
                      url: _ctx.publicUrl,
                      title: _ctx.content.alternativeTitle || _ctx.content.title,
                      description: _ctx.stripTags(_ctx.content.alternativeLead || _ctx.content.lead),
                      quote: _ctx.stripTags(_ctx.content.alternativeLead || _ctx.content.lead),
                      onClickCapture: ($event: any) => (_ctx.measureShare(social))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(social)))
                      ]),
                      _: 2
                    }, 1032, ["class", "network", "url", "title", "description", "quote", "onClickCapture"])
                  }), 64))
                ]),
                _createVNode(_component_facebook_follow, { type: "mobile" }),
                (_ctx.content.tags?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.content.headingTag)
                        ? (_openBlock(), _createBlock(_component_tag, {
                            key: 0,
                            class: "static-page__bottom-tag",
                            tag: _ctx.content.headingTag,
                            "show-hashtag": true,
                            "show-color": false,
                            "is-link": true,
                            "prefer-tag-link": true,
                            onClickCapture: _cache[6] || (_cache[6] = ($event: any) => (_ctx.measureTag(_ctx.content.headingTag.tag)))
                          }, null, 8, ["tag"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_tag, {
                          class: "static-page__bottom-tag",
                          key: tag.id,
                          tag: tag,
                          "show-hashtag": true,
                          "show-color": false,
                          "is-link": true,
                          onClickCapture: ($event: any) => (_ctx.measureTag(tag.tag))
                        }, null, 8, ["tag", "onClickCapture"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "afterContent"),
                (_ctx.contentBody && _ctx.contentBody.scripts)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentBody?.scripts, (script) => {
                        return (_openBlock(), _createBlock(_component_dynamic_script, _mergeProps(script.attrs, {
                          content: script.content
                        }), null, 16, ["content"]))
                      }), 256))
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["title"])
          ]),
          _: 3
        }, 8, ["age-rating"]))
      : _createCommentVNode("", true),
    (_ctx.enableRecommendedVideos && _ctx.showRecommendedVideos)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#site-placeholder--header"
        }, [
          _createVNode(_component_recommended_video_widget, { class: "static-page__recommended-video" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}